/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const UNPROCESSABLE_ENTITY = 422;
export const CONSTRAINT_VIOLATION = 409;
export const GLOBAL = 'global';
export const CONSEQUENCE_AWARE_DELETION = 'This will affect all customers that are entitled to this role.';
export const CAN_NOT_BE_UNDONE_MESSAGE = 'This action cannot be undone.';
export const DELETE_GLOBAL_ROLE_CONFIRMATION = 'I understand the consequences, delete this global role';
